const API_BASE_URL = "https://noc.onlinetn.com/api";
const FILE_BASE_URL = "https://noc.onlinetn.com/uploads";

export { API_BASE_URL, FILE_BASE_URL };